import React from 'react';

const Guarantor = () => {
  return <div>Guarantor</div>;
};

export default Guarantor;
